import PageLayout from "Layouts/PageLayout";
import { useTranslation } from "react-i18next";
import CustomerForm from "Features/Customers/Components/CustomerForm";
import { useNavigate } from "react-router-dom";
import HandsIcon from "Assets/SVG/HandsIcon";

const New = () => {
    
    const { t } = useTranslation();
    
    const navigate = useNavigate();
    
    return (
        <PageLayout title={t('newCustomer')} icon={<HandsIcon />} includeBox>
            <CustomerForm onSubmit={_ => navigate(-1)} />
        </PageLayout>
    )
}

export default New
